import script from "./mosuannai_order.vue?vue&type=script&setup=true&lang=js"
export * from "./mosuannai_order.vue?vue&type=script&setup=true&lang=js"

import "./mosuannai_order.vue?vue&type=style&index=0&id=9e35cf22&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9e35cf22"]])

export default __exports__